<template>
    <div>
        <div class="white-box white-box-no-tab text-base xs:text-lg pb-10">
            <Skeletons v-if="isSkeleton" />
            <template v-else>
                <Title
                    styleCodePage
                    :text="$route.meta.pageTitle"
                />

                <h4 class="py-3 md:pb-3.5 md:pt-0">
                    請選擇您欲申請信用卡授權的保單
                </h4>
                <Nodata v-if="policyList.length === 0">
                    無保單資料
                </Nodata>
                <template v-else>
                    <Nodata v-if="selectPolicyList.length === 0">
                        無可申請之保單
                    </Nodata>
                    <template v-if="selectPolicyList.length>0">
                        <PolicyCard
                            v-model:selectedList="selectedList"
                            :data="selectPolicyList"
                            class="lg:hidden"
                            @checkedPolicy="checkedPolicy"
                        >
                            <template #pickAll>
                                <Checkbox
                                    v-model:checkedValues="isAllPolicy"
                                    :value="true"
                                    text="全選"
                                    class="items-baseline mr-0 mb-1"
                                    @change="selectAll"
                                />
                            </template>
                        </PolicyCard>
                        <!-- for computer -->
                        <PolicyTable
                            v-model:selectedList="selectedList"
                            :data="selectPolicyList"
                            class="hidden lg:block"
                            @checkedPolicy="checkedPolicy"
                        >
                            <template #pickAll>
                                <Checkbox
                                    v-model:checkedValues="isAllPolicy"
                                    :value="true"
                                    :borderLight="true"
                                    class="items-baseline mb-0 mr-0 border-1"
                                    @change="selectAll"
                                />
                            </template>
                        </PolicyTable>
                    </template>
                    <template v-if="disabledPolicyList.length > 0">
                        <h5 class="pb-3 pt-8">
                            無法辦理之保單
                        </h5>

                        <PolicyCard
                            :data="disabledPolicyList"
                            disabled
                            class="lg:hidden"
                        />
                        <!-- for computer -->
                        <PolicyTable
                            :data="disabledPolicyList"
                            disabled
                            class="hidden lg:block"
                        />
                    </template>
                </template>
            </template>
        </div>
        <Bottombar :control-visible="selectedList.length>0">
            <template #right>
                <button
                    class="btn btn-accent rounded-full"
                    :disabled="selectedList.length===0 || isLoading"
                    @click="goNext()"
                >
                    下一步
                </button>
            </template>
        </Bottombar>
        <Loading :isLoading="isLoading" />
    </div>
</template>

<script>
import { ref, inject, computed } from 'vue';
import { useRouter } from 'vue-router';
import Title from '@/components/text/Title.vue';
import Skeletons from '@/components/skeletons/SkeletonsCardTable.vue';
import PolicyCard from './PolicyCard.vue';
import PolicyTable from './PolicyTable.vue';
import Nodata from '@/components/text/EmptyData.vue';
import Checkbox from '@/components/checkboxs/Checkbox.vue';
import Bottombar from '@/components/layout/Bottombar.vue';
import Loading from '@/components/Loading.vue';
import routeName from '@/router/constant.js';
import dialogContent from '@/json/dialogContent';
import store from '../../../store';
import codeList from '@/json/codeList.js';
import { getInfoCreditCardAuth, submitCreditCardAuth } from '@/apis/aplCatlCreditCardAuth';

export default {
    components: {
        Title,
        Bottombar,
        Loading,
        PolicyCard,
        PolicyTable,
        Nodata,
        Checkbox,
        Skeletons,
    },
    setup() {
        const $vfm = inject('$vfm');
        const router = useRouter();
        // 幣別，只判斷NTD
        const currency = ref('NTD');
        // 全部的保單
        const policyList = ref([]);
        // 不可以勾選的列表
        const disabledPolicyList = ref([]);
        // 可以勾選的列表
        const selectPolicyList = ref([]);
        // 勾選的保單號碼
        const selectedList = ref([]);
        const isSkeleton = ref(false);
        const isLoading = ref(false);
        // 是否全選
        const isAllPolicy = ref(false);

        const resultUserInfo = computed(() => store.state.services.changeItemsResult[`${codeList.CREDIT_CARD_AUTH}policy`]);

        const makeList = ({ useStoreData }) => {
            if (!useStoreData) {
                selectedList.value = [];
            }
            disabledPolicyList.value = [];
            selectPolicyList.value = [];
            const foreignCurrency = currency.value !== 'NTD';
            policyList.value.forEach(i => {
                if (i.foreignCurrency === foreignCurrency) {
                    if (i.disable) {
                        disabledPolicyList.value.push(i);
                    } else {
                        selectPolicyList.value.push(i);
                    }
                }
            });
        };
        // 取得內容
        const getData = () => {
            isSkeleton.value = true;
            getInfoCreditCardAuth().then((res) => {
                policyList.value = res.data.policyList;

                if (resultUserInfo.value) {
                    currency.value = resultUserInfo.value.currency;
                    selectedList.value = resultUserInfo.value.selectedList;
                    makeList({ useStoreData: true });
                } else {
                    makeList({ useStoreData: false });
                }
                isSkeleton.value = false;
            });
        };
        getData();

        // 全選/反選取
        const selectAll = () => {
            selectedList.value = isAllPolicy.value ? selectPolicyList.value.map(i => i.fullPolicyNo) : [];
        };

        // 勾選/反選取保單
        const checkedPolicy = (itemNo) => {
            selectedList.value = selectedList.value.includes(itemNo)
                ? selectedList.value.filter(i => i !== itemNo) : [...selectedList.value, itemNo];
            isAllPolicy.value = selectPolicyList.value.length === selectedList.value.length;
        };
        const modalShow = (params, on) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on
            });
        };

        const goNext = () => {
            isLoading.value = true;
            const policyList = selectedList.value.map(i => {
                const obj = selectPolicyList.value.find(j => j.fullPolicyNo === i);
                if (obj) {
                    const { policyNo, policySeq, idDup, srceFrom } = obj;
                    return { policyNo, policySeq, idDup, srceFrom };
                } else {
                    isLoading.value = false;
                    modalShow(dialogContent.refresh, {
                        confirm() {
                            $vfm.hide('DialogBase');
                            router.go(0);
                        },
                    });
                }
            });
            const info = {
                foreignCurrency: currency.value === '',
                policyList,
            };
            const userData = {
                selectedList: selectedList.value,
                currency: currency.value
            };

            submitCreditCardAuth(info).then(() => {
                store.dispatch('services/setChangeItemsResult', { code: `${codeList.CREDIT_CARD_AUTH}policy`, value: userData });
                router.push({ name: routeName.CONFIRM_DATA });
            }).catch(() => {
                isLoading.value = false;
            });
        };
        return {
            currency,
            isSkeleton,
            policyList,
            selectPolicyList,
            disabledPolicyList,
            selectedList,
            isAllPolicy,
            isLoading,
            selectAll,
            makeList,
            checkedPolicy,
            goNext
        };
    },
};
</script>
